export type Theme = 'system' | 'light' | 'dark';
const storageKey = 'pickpro.theme';

export const readTheme = (): Theme => {
  try {
    const saved = window.localStorage.getItem(storageKey);
    return saved === 'light' || saved === 'dark' ? saved : 'system';
  } catch {
    return 'system';
  }
};

export const applyTheme = (theme: Theme) => {
  if (theme === 'system') delete document.documentElement.dataset.theme;
  else document.documentElement.dataset.theme = theme;
};

export const initializeTheme = (): Theme => {
  const theme = readTheme();
  applyTheme(theme);
  return theme;
};

export const saveTheme = (theme: Theme) => {
  applyTheme(theme);
  try {
    if (theme === 'system') window.localStorage.removeItem(storageKey);
    else window.localStorage.setItem(storageKey, theme);
  } catch {
    return;
  }
};
